export const Skeleton = {
  baseStyle: {
    opacity: 0.7,
    borderRadius: '2px',
    borderColor: 'var(--loader)',
    background: 'var(--loader)',
    animation: 'loaderAnimation 1.2s linear infinite alternate'
  }
}
